module.exports = __webpack_public_path__ + "media/n10.d234283d.mp4";